<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Reg. Nr. gautų dokumentų žurnale"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Reg nr gautų dokumentų žurnale"
                  v-model="mainData['journal_no-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Identifikavimo kodas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Identifikavimo kodas"
                  v-model="mainData['mandate_code-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="enumsClassifiers.receiveMode"
                  :predefined-order="enumsClassifiers.receiveModePredefinedOrder"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Gavimo būdas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Gavimo būdas"
                  v-model="mainData['receive_mode-search-simple']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="filteredInJournalType"
                  multiple
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Gauto dokumento pavadinimas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Gauto dokumento pavadinimas"
                  v-model="mainData['in_journal_type-search-in']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="enumsClassifiers.dataProviderType"
                  multiple
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Duomenų teikėjo tipas"
                  v-model="mainData['data_provider_type-search-in']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="enumsClassifiers.inJournalStatus"
                  multiple
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Pranešimo būsena"
                  v-model="mainData['status-search-custom']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <el-text-field
                  label="Reg. Nr. nepatikrintų dokumentų žurnale"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Reg. Nr. nepatikrintų dokumentų žurnale"
                  v-model="mainData['ns_number_gdz-search-custom']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :beforeDates="mainData['date_received-search-to']"
                  label="Gavimo data nuo"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Gavimo data nuo"
                  v-model="mainData['date_received-search-from']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :afterDates="mainData['date_received-search-from']"
                  label="Gavimo data iki"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Gavimo data iki"
                  v-model="mainData['date_received-search-to']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn @downloadReport="downloadReport" object="in-journals" :loading="loading" :reportData="reportData"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'
import moment from 'moment'

export default {
  name: 'AdminJournalReceivedSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    filteredInJournalType(){
      let hideKeys = ['404','406']
      hideKeys.map(key =>{
       delete this.enumsClassifiers.inJournalType.lt[key]
       delete this.enumsClassifiers.inJournalType.en[key]
      })
      return  this.enumsClassifiers.inJournalType
    },
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    // this.setDateFrom()
     this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setDateFrom(){
      if(!this.mainData.autoSet){
        let date = moment().subtract(3, 'days').format('YYYY-MM-DD') 
        this.$set(this.mainData, 'date_received-search-from', date)
        this.$set(this.mainData, 'autoSet', true)
      } 
      this.searchData()
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      let autoSet = this.mainData?.autoSet || false
      this.mainData = {isExpanded: true, clear: true}
      this.$nextTick(() => {
        this.mainData = { isExpanded: true, autoSet: autoSet }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.searchData(true)
        } 
      })
    },
  },
}
</script>
